(function() {
    document.addEventListener('DOMContentLoaded', function() {
        var panels = document.querySelectorAll('.mms-mega-panel');

        panels.forEach(function(panel) {
            var enableToggle = panel.dataset.enableToggle === '1';
            var limit = parseInt(panel.dataset.visibleLimit || '0');
            // Get blocks as an array to allow sorting
            var blocks = Array.from(panel.querySelectorAll('.mms-block'));
            var viewMore = panel.querySelector('.mms-view-more');
            var viewLess = panel.querySelector('.mms-view-less');
            var mq = window.matchMedia('(max-width: 991px)'); // Updated breakpoint to match CSS

            // Hamburger Toggle Logic
            var toggler = document.querySelector('.navbar-toggler');
            var menu = document.querySelector('.mms-mega-menu');

            if (toggler && menu && !toggler.dataset.mmsInitialized) {
                toggler.addEventListener('click', function(e) {
                    e.preventDefault();
                    e.stopPropagation(); // Prevent bubbling if needed
                    menu.classList.toggle('mms-open');
                    toggler.classList.toggle('mms-active');
                });
                toggler.dataset.mmsInitialized = 'true'; // Prevent multiple listeners if multiple panels exist
            }

            // CSS order values are static — compute once before any DOM mutations.
            var sortedBlocks = blocks.slice().sort(function(a, b) {
                return (parseInt(window.getComputedStyle(a).order) || 0)
                     - (parseInt(window.getComputedStyle(b).order) || 0);
            });

            function hideExtra() {
                if (!enableToggle || limit <= 0) return;

                var visibleCount = 0;

                sortedBlocks.forEach(function(block) {
                    // Ignore blocks that are permanently hidden on mobile via CMS
                    if (block.classList.contains('mms-hide-mobile')) {
                        return;
                    }

                    if (visibleCount < limit) {
                        block.style.display = ''; // Reset to default (flex/block)
                        visibleCount++;
                    } else {
                        block.style.display = 'none';
                    }
                });
            }

            function showAll() {
                blocks.forEach(function(block) {
                    // Don't show blocks that are supposed to be hidden on mobile
                    if (mq.matches && block.classList.contains('mms-hide-mobile')) {
                        block.style.display = ''; // Let CSS !important handle it, or keep it hidden?
                        // CSS has .mms-hide-mobile { display: none !important; } so setting style.display = '' is fine.
                    } else {
                        block.style.display = '';
                    }
                });
            }

            function updateToggle() {
                if (!enableToggle) return;

                if (mq.matches) {
                    // Mobile: Apply limit
                    hideExtra();
                    if (viewMore) viewMore.style.display = '';
                    if (viewLess) viewLess.style.display = 'none';
                } else {
                    // Desktop: Show all
                    showAll();
                    if (viewMore) viewMore.style.display = 'none';
                    if (viewLess) viewLess.style.display = 'none';
                }
            }

            if (viewMore) {
                viewMore.addEventListener('click', function() {
                    showAll();
                    viewMore.style.display = 'none';
                    if (viewLess) viewLess.style.display = '';
                });
            }
            if (viewLess) {
                viewLess.addEventListener('click', function() {
                    hideExtra();
                    viewLess.style.display = 'none';
                    if (viewMore) viewMore.style.display = '';
                });
            }

            // Initial state
            updateToggle();
            mq.addEventListener('change', updateToggle);
        });
    });

    document.querySelectorAll('.mms-mega-menu .menu-item-has-children a').forEach(function(item) {
        item.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            const parentMenuItem = this.closest('.menu-item-has-children');
            if (parentMenuItem) {
                parentMenuItem.classList.toggle('show-children');
            }
        });
    });

    const desktopBreakpoint = 1080;

    function setupMenuItemEvents() {
        document.querySelectorAll('.menu-item-type-custom').forEach(function(menuItem) {
            const link = menuItem.querySelector('a');
            const megaPanel = menuItem.querySelector('.mms-mega-panel');

            const oldClickListener = menuItem.dataset.clickListener;
            if (oldClickListener) {
                link.removeEventListener('click', eval(oldClickListener));
                delete menuItem.dataset.clickListener;
            }
            const oldMouseEnterListener = menuItem.dataset.mouseEnterListener;
            if (oldMouseEnterListener) {
                menuItem.removeEventListener('mouseenter', eval(oldMouseEnterListener));
                delete menuItem.dataset.mouseEnterListener;
            }
            const oldMouseLeaveListener = menuItem.dataset.mouseLeaveListener;
            if (oldMouseLeaveListener) {
                menuItem.removeEventListener('mouseleave', eval(oldMouseLeaveListener));
                delete menuItem.dataset.mouseLeaveListener;
            }

            // Reset state for all items
            menuItem.classList.remove('desk-open');
            if (megaPanel) {
                megaPanel.style.right = '';
            }

            if (window.innerWidth > desktopBreakpoint) {
                // Desktop: Hover behavior
                const handleMouseEnter = function() {
                    document.querySelectorAll('.menu-item-type-custom.desk-open').forEach(function(item) {
                        if (item !== menuItem) {
                            item.classList.remove('desk-open');
                            const otherPanel = item.querySelector('.mms-mega-panel');
                            if (otherPanel) otherPanel.style.right = '';
                        }
                    });

                    menuItem.classList.add('desk-open');
                    if (megaPanel) {
                        const menuContainer = document.querySelector('.menu-new-menu-container');
                        if (menuContainer) {
                            const menuContainerRect = menuContainer.getBoundingClientRect();
                            const currentItemRect = menuItem.getBoundingClientRect();
                            const rightOffset = -(menuContainerRect.right - currentItemRect.right);
                            megaPanel.style.right = `${rightOffset}px`;
                        }
                    }
                };
                const handleMouseLeave = function() {
                    menuItem.classList.remove('desk-open');
                    if (megaPanel) {
                        megaPanel.style.right = '';
                    }
                };

                menuItem.addEventListener('mouseenter', handleMouseEnter);
                menuItem.addEventListener('mouseleave', handleMouseLeave);
                menuItem.dataset.mouseEnterListener = handleMouseEnter.name || handleMouseEnter.toString();
                menuItem.dataset.mouseLeaveListener = handleMouseLeave.name || handleMouseLeave.toString();

            } else {
                // Mobile/Tablet: Click behavior
                const handleClick = function(e) {
                    e.preventDefault();
                    e.stopPropagation();

                    document.querySelectorAll('.menu-item-type-custom.desk-open').forEach(function(item) {
                        if (item !== menuItem) {
                            item.classList.remove('desk-open');
                            const otherPanel = item.querySelector('.mms-mega-panel');
                            if (otherPanel) otherPanel.style.right = '';
                        }
                    });

                    menuItem.classList.toggle('desk-open');
                    if (megaPanel) {
                        // On mobile/tablet, panel should not have complex right positioning
                        megaPanel.style.right = '';
                    }
                };
                link.addEventListener('click', handleClick);
                link.dataset.clickListener = handleClick.name || handleClick.toString();
            }
        });
    }

    // Initial setup
    setupMenuItemEvents();

    // Re-setup on window resize
    window.addEventListener('resize', function() {
        setupMenuItemEvents();
    });

})();
